export default __webpack_public_path__ + "static/media/pointing.97d9afc2.png";